import { render, staticRenderFns } from "./VAutoSectionHeader.vue?vue&type=template&id=c8f43414&scoped=true"
import script from "./VAutoSectionHeader.vue?vue&type=script&lang=js"
export * from "./VAutoSectionHeader.vue?vue&type=script&lang=js"
import "./VAutoSectionHeader.vue?vue&type=style&index=0&id=c8f43414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f43414",
  null
  
)

export default component.exports